module.exports = __webpack_public_path__ + "img/team-2.ac768bda.jpg";